module.exports = __webpack_public_path__ + "img/[吐].fa0641ac.svg";